import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withKeys as _withKeys, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dbf1b804"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "slider-props-component" }
const _hoisted_2 = { class: "info" }
const _hoisted_3 = {
  class: "information-text",
  for: "number"
}
const _hoisted_4 = ["v-model", "value", "onKeyup"]
const _hoisted_5 = ["id", "step", "min", "max"]

import { computed, ref } from "vue";
import { formatter } from "@/formatter";
import { find } from "@vue/test-utils/dist/utils/find";


export default /*#__PURE__*/_defineComponent({
  __name: 'SliderPropsComponent',
  props: {
  informationText: {
    type: String,
    default: "Infotext",
    required: true,
  },
  numberValue: {
    type: Number,
    default: 850,
    required: true,
  },
  stepForSlider: {
    type: Number,
    default: 10,
    required: true,
  },
  minimumRange: {
    type: Number,
    default: 0,
    required: true,
  },
  maximumRange: {
    type: Number,
    default: 1000,
    required: true,
  },
  dataType: {
    type: String,
    default: "",
    required: true,
  },
  sliderID: {
    type: String,
    default: "ID",
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
},
  emits: ["calculate"],
  setup(__props, { emit }) {

const props = __props;





const slider = ref(null);
const currentValueForSlider = ref(props.numberValue);
const field = ref("");

function handleKeyUp(event: any) {
  //key code for enter
  // We use this method to de-select a textfield when we press enter.
  if (event.keyCode === 13) {
    event.preventDefault();
    event.target.blur();
  }
}

/*function handleInput(event: any) {
  event.target.value
    // Add a space after every set of 4 digits
    .replace(/(.{4})/g, "$1 ")
    // Remove the space after the last set of digits
    .trim();

  emit("calculate", currentValueForSlider.value);
}*/

const handleInput = computed(() => {
  return emit("calculate", currentValueForSlider.value);
});

function handleDrag(event: any) {
  // if we start to drag on a slider, and we're still inside a text field, we need to de-select any active text field.
  let fields = document.getElementById("number");
  if (fields !== null) {
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
  }
}

function handleChange(event: any) {
  // we make sure here that the formatting is correct after input.
  event.target.value =
    formatter.format(event.target.value) + ` ${props.dataType}`;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", _hoisted_3, _toDisplayString(__props.informationText), 1),
      _createElementVNode("input", {
        id: "number",
        ref_key: "field",
        ref: field,
        "v-model": currentValueForSlider.value,
        value: _unref(formatter).format(currentValueForSlider.value) + ` ${props.dataType}`,
        type: "text",
        pattern: "[0-9]*",
        class: "textfield",
        name: "textfield",
        oninput: "this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\\..*?)\\..*/g, '$1');",
        onChange: handleChange,
        onKeyup: _withKeys(handleKeyUp, ["enter"]),
        onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (handleInput.value && handleInput.value(...args)))
      }, null, 40, _hoisted_4)
    ]),
    _withDirectives(_createElementVNode("input", {
      id: __props.sliderID,
      ref_key: "slider",
      ref: slider,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((currentValueForSlider).value = $event)),
      class: "slider",
      type: "range",
      step: __props.stepForSlider,
      min: __props.minimumRange,
      max: __props.maximumRange,
      tabindex: "-1",
      onChange: handleDrag,
      onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('calculate', currentValueForSlider.value)))
    }, null, 40, _hoisted_5), [
      [
        _vModelText,
        currentValueForSlider.value,
        void 0,
        { number: true }
      ]
    ])
  ]))
}
}

})